import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import { ROUTES } from '@/constants';

/**
 * Protects routes that require authentication.
 * Redirects to login if user is not authenticated.
 */
export function AuthGuard({ children }) {
    const { user, isAuthenticated, isLoading } = useAuthContext();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            </div>
        );
    }

    if (!isAuthenticated) {
        // Open the login panel on the landing page when user is not authenticated.
        return (
            <Navigate
                to={`${ROUTES.HOME}?login=1`}
                state={{ from: location }}
                replace
            />
        );
    }

    // A temporary password must be replaced before anything else is reachable.
    const onChangePassword = location.pathname === ROUTES.CHANGE_PASSWORD;
    if (user && !user.passwordChanged && !onChangePassword) {
        return <Navigate to={ROUTES.CHANGE_PASSWORD} replace />;
    }

    return children;
}

export default AuthGuard;
